import React from "react";
import {
  Grid,
  Button,
  Typography,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import { green, yellow, orange, red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useCardStyles, bodyTextSize } from "../lib/constants";
import TaxonomyData from "../taxonomyData.json";
import { TAXONOMY_TAGS } from "../epics/stepThreeEpics";
import { setPageNumber } from "../epics/pageNumberEpic";
import { addCheckedTags } from "../epics/stepThreeEpics";
import DynamicText from "./DynamicTextComponent";

const calculateTaxonomyPositions = (text, tags) => ({
  type: TAXONOMY_TAGS,
  payload: {
    text: text,
    tags: tags
  }
});

const useStyles = makeStyles(
  {
    scoresContainer: {
      width: "100%",
      height: "40px",
      marginBottom: "7px"
    },
    scoreContainer: {
      fontWeight: 500
    },
    dynamicTextRoot: {
      display: "flex",
      width: "100%",
      flexGrow: 1,
      flexShrink: 1,
      overflow: "hidden"
    },
    headingText: {
      fontSize: "1.2rem"
    }
  },
  { name: "Textcard2Styles" }
);

function getTextFromScore(sentenceScores, txt, checkedText) {
  const score = sentenceScores[txt];
  let color = undefined;
  let text = undefined;
  switch (score) {
    case 0:
      text = "Sehr verwandt";
      color = green[500];
      break;
    case 1:
      text = "Verwandt";
      color = green[200];
      break;
    case 2:
      text = "Etwas verwandt";
      color = yellow[500];
      break;
    case 3:
      text = "Wenig verwandt";
      color = yellow[700];
      break;
    case 4:
      text = "Kaum verwandt";
      color = orange[200];
      break;
    default:
      text = "Nicht verwandt";
      color = red[500];
      break;
  }
  return !Number.isNaN(score) ? (
    <p
      style={{
        color: color,
        fontSize: bodyTextSize,
        textTransform: "uppercase"
      }}
    >
      {text}
    </p>
  ) : undefined;
}

export default function TextCard2(props) {
  const classes = useStyles();

  const { header, text, onCheck, resize } = props;

  const pageNumber = useSelector((state) => state.pageNumber);
  const styleProps = { page: pageNumber, sizeBreak: resize[0] };
  const cardClasses = useCardStyles(styleProps);
  const checkedStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedTextStepTwo = useSelector((state) => state.checkedCardStepTwo);
  const sentenceScore = useSelector((state) => state.sentenceScore);
  const keyphrases = useSelector((state) => state.keyphrases);
  const checkedTags = useSelector((state) => state.checkedTags);

  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const scoreText = checkedStepOne + " " + text;
  const scoreContentText = getTextFromScore(sentenceScore, scoreText, checkedStepOne);
  const scoreContent = scoreContentText === undefined ? <CircularProgress /> : scoreContentText;
  return (
    <div className={cardClasses.root}>
      <Typography
        className={cardClasses.flexNoGrowNoShrink}
        variant="subtitle2"
        classes={{ root: classes.headingText }}
      >
        {header}
      </Typography>
      <div className={classes.dynamicTextRoot}>
        <DynamicText onReadMoreClick={() => handleClickOpen()}>{text}</DynamicText>
      </div>
      <Dialog open={open} onClose={handleClose} classes={{ paper: cardClasses.dialogStyling }}>
        <DialogTitle id={header} classes={{ root: cardClasses.dialogHeaderStyling }}>
          {header}
        </DialogTitle>
        <DialogContent classes={{ root: cardClasses.dialogContentContainer }}>
          <DialogContentText id="readmore-content" classes={{ root: cardClasses.dialogBodyStyling }}>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions classes={{ root: cardClasses.dialogActionStyling }}>
          <Grid container alignItems="center" justifyContent="center" className={cardClasses.closeButtonContainer}>
            <Button
              onClick={handleClose}
              color="primary"
              variant="outlined"
              classes={{ root: cardClasses.dialogButtonStyling }}
            >
              Schließen
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>

      <Grid container alignContent="center" justifyContent="center" classes={{ root: classes.scoresContainer }}>
        <Grid container alignItems="center" justifyContent="center" classes={{ root: classes.scoreContainer }}>
          {scoreContent}
        </Grid>
      </Grid>
      <div className={cardClasses.checkBoxContainer}>
        <Button
          variant={checkedTextStepTwo === text ? "contained" : "outlined"}
          classes={{ root: cardClasses.buttonStyling }}
          color="primary"
          onClick={() => {
            if (onCheck !== undefined && checkedTextStepTwo !== text) {
              onCheck(text);
              const taxData = [];
              Object.keys(TaxonomyData).forEach((key) => taxData.push(...TaxonomyData[key]));
              const data = keyphrases[checkedStepOne + " " + text];
              if (data) {
                Object.keys(data).forEach((key) => taxData.push(key));
                dispatch(calculateTaxonomyPositions(checkedStepOne + " " + text, taxData));
                dispatch(setPageNumber(pageNumber + 1));
                if (_.isEmpty(checkedTags[checkedStepOne + " " + text])) {
                  dispatch(addCheckedTags(checkedStepOne + " " + text, Object.keys(data)));
                }
              }
            }
          }}
        >
          {checkedTextStepTwo === text ? "ausgewählt" : "auswählen"}
        </Button>
      </div>
    </div>
  );
}
